import React from 'react';
import { motion } from 'framer-motion';
import { useCurrencyDetection } from '../hooks/useCurrencyDetection';
const bonuses = [{
  title: 'Pan Siempre Fresco',
  desc: 'Manual de Congelación y Conservación Pro',
  value: 27,
  image: 'https://cdn.magicpatterns.com/uploads/dRRqdUnCQQUAKyAvQHfZWU/Sistema-Pan-Siempre-Fresco-Mockup.webp'
}, {
  title: 'Cenas Express en 15 Minutos',
  desc: 'Recetas saladas rápidas para noches sin estrés',
  value: 15,
  image: 'https://cdn.magicpatterns.com/uploads/fxARktckF7XxX9dyGzY5UN/Cena-Express-15-Min-Mockup.webp'
}, {
  title: 'El Arte de la Masa Madre Sin Gluten',
  desc: 'Aprende a crear tu propio fermento natural probiótico desde cero.',
  value: 19,
  image: 'https://cdn.magicpatterns.com/uploads/5i8jFwzBE8FKu9DmDCVx5u/El-Arte-Masa-Madre-Mockup.webp'
}, {
  title: 'Cómo Salvar una Masa',
  desc: 'Corregir cualquier error técnico y nunca más tirar ingredientes a la basura.',
  value: 29,
  image: 'https://cdn.magicpatterns.com/uploads/1NyMy8cZodL6QgM1xTxBTQ/Manual-Rescate-Mockup.webp'
}];
export function BonusSection() {
  const {
    totalPrice,
    todayPrice
  } = useCurrencyDetection();
  const handleCheckout = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    const redirectUrl = 'https://trk.chefalessandra.com/click';
    if (window.fbq) {
      window.fbq('track', 'InitiateCheckout', {
        content_name: 'Tu Panadería Sin Gluten en Casa',
        num_items: 3,
        currency: 'USD',
        value: 9.90
      });
    }
    window.open(redirectUrl, '_blank');
  };
  return <section id="oferta" className="py-5 px-4 bg-[#FFFDF9] relative overflow-hidden" data-id="element-35">
      {/* Decorative background elements */}
      <div className="absolute top-0 left-0 w-full h-2 bg-gradient-to-r from-brand-gold via-yellow-300 to-brand-gold" data-id="element-36"></div>
      <div className="absolute -right-40 -top-40 w-96 h-96 bg-brand-gold/10 rounded-full blur-3xl" data-id="element-37"></div>
      <div className="absolute -left-40 -bottom-40 w-96 h-96 bg-brand-gold/10 rounded-full blur-3xl" data-id="element-38"></div>

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-39">
        <motion.div initial={{
        opacity: 0,
        y: 10
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-6" data-id="element-40">
          <h2 className="text-3xl md:text-5xl font-heading font-bold text-brand-brown" data-id="element-41">
            SOLO POR HOY TE REGALAMOS:
          </h2>
        </motion.div>

        <div className="grid grid-cols-2 gap-4 md:gap-6 mb-6" data-id="element-42">
          {bonuses.map((bonus, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: idx * 0.15
        }} className="bg-white border-2 border-brand-gold/30 rounded-2xl p-6 flex flex-col items-center text-center shadow-lg hover:border-brand-gold transition-colors" data-id="element-43">
              {bonus.image ? <div className="-mx-6 -mt-4 rounded-2xl overflow-hidden mb-4" data-id="element-44">
                  <img src={bonus.image} alt={bonus.title} className="w-full h-36 md:h-44 object-cover object-[center_30%]" data-id="element-45" />
                </div> : <div className="bg-brand-gold/10 p-4 rounded-xl mb-4" data-id="element-46">
                  <span className="text-4xl block mb-1" data-id="element-47">🎁</span>
                  <span className="text-brand-brown font-bold text-xs uppercase tracking-wider" data-id="element-48">
                    Bono #{idx + 1}
                  </span>
                </div>}

              <h3 className="text-lg md:text-xl font-bold text-brand-brown mb-2 leading-snug" data-id="element-49">
                {bonus.title}
              </h3>
              <p className="text-brand-brownLight text-sm leading-relaxed mb-1 flex-grow" data-id="element-50">
                {bonus.desc}
              </p>

              <div className="bg-brand-cream px-4 py-3 rounded-lg text-center w-full border border-brand-gold/20" data-id="element-51">
                <p className="text-sm text-brand-brownLight line-through mb-1" data-id="element-52">
                  Valor USD {bonus.value}
                </p>
                <p className="text-brand-green font-bold text-xl uppercase" data-id="element-53">
                  HOY GRATIS
                </p>
              </div>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-brand-brown text-white rounded-2xl p-8 text-center shadow-2xl border border-brand-gold/50 overflow-hidden" data-id="element-54">
          <div className="relative w-full max-w-lg mx-auto mb-6" data-id="element-55">
            <motion.div animate={{
            rotate: [-5, 5, -5]
          }} transition={{
            repeat: Infinity,
            duration: 4,
            ease: 'easeInOut'
          }} className="absolute -top-4 -right-4 bg-brand-red text-white w-24 h-24 rounded-full flex flex-col items-center justify-center shadow-xl z-10 border-4 border-white" data-id="element-56">
              <span className="text-sm font-bold uppercase" data-id="element-57">Ahorra</span>
              <span className="text-2xl font-bold" data-id="element-58">90%</span>
            </motion.div>
            <img src="https://cdn.magicpatterns.com/uploads/crNXrnSjMadow4ae74LrKG/Pack7Ebooks_(1).webp" alt="Pack completo de 7 Ebooks Sin Gluten — Panadería, Bizcochos, Postres y Bonos" className="w-full rounded-xl" data-id="element-59" />
          </div>

          <p className="text-lg text-white/80 mb-2" data-id="element-60">
            Si compraras todo por separado:
          </p>
          <p className="text-3xl md:text-4xl font-heading font-bold text-white/50 line-through mb-4" data-id="element-61">
            VALOR TOTAL: {totalPrice}
          </p>
          <p className="text-3xl md:text-4xl font-heading font-bold text-white mb-4" data-id="element-62">
            SOLO POR HOY {todayPrice}
          </p>

          <a href="https://trk.chefalessandra.com/click" onClick={handleCheckout} className="w-full bg-brand-terracotta text-white text-xl md:text-2xl font-bold py-6 px-6 md:px-10 rounded-2xl shadow-[0_10px_30px_rgba(196,93,44,0.4)] flex items-center justify-center gap-3 mt-6 mb-4 whitespace-nowrap" data-id="element-63">
            QUIERO EL COMBO 3×1 ➤
          </a>

          <p className="text-xl md:text-2xl font-bold text-brand-gold" data-id="element-64">
            3 ebooks principales · 4 ebooks de regalo · +160 recetas
          </p>
        </motion.div>
      </div>
    </section>;
}